import {
  ArrowRightDoubleIcon,
  ArrowLeftDoubleIcon,
  PlayIcon
} from '@hugeicons/react'

import _ from 'lodash'

import { Button } from '@/shared/ui/Button'
import { LevelPlay } from '@/shared/ui/LevelPlay'

import { DigitalProductQuizQuizPlayQuestionFooterIntroButton } from './IntroButton'
import { DigitalProductQuizQuizPlayQuestionFooterRightAnswerAlert } from './RightAnswerAlert'
import { DigitalProductQuizQuizPlayQuestionFooterWrongAnswerAlert } from './WrongAnswerAlert'
import { useQuizContext } from '../../../context'

export const DigitalProductQuizQuizPlayQuestionFooter = ({
  id,
  activity = {},
  step,
  interactionMode
}) => {
  const {
    isSubmitting,
    disableControls,

    answerIsWrong,
    answerIsRight,

    onQuestionRetry,
    onQuestionAdvance,

    stepsCustomFooters,
    allowWrongAnswers,

    goToPrevStep,
    goToNextStep,

    onQuestionContinue
  } = useQuizContext()
  let { save_answer: saveAnswer = false } = activity.meta

  if (stepsCustomFooters[step.id])
    return (
      <LevelPlay.Footer id={id}>
        {step.hasIntro && (
          <DigitalProductQuizQuizPlayQuestionFooterIntroButton />
        )}

        {stepsCustomFooters[step.id]}
      </LevelPlay.Footer>
    )
  if (step.isIntro)
    return (
      <LevelPlay.Footer id={id}>
        <Button
          variant="primary"
          className="grow"
          showTrailingIcon={false}
          leadingIcon={<PlayIcon size={20} variant="duotone" />}
          onClick={goToNextStep}
        >
          Avançar
        </Button>
      </LevelPlay.Footer>
    )
  if (step.isSlide)
    return (
      <LevelPlay.Footer id={id}>
        {step.hasIntro && (
          <DigitalProductQuizQuizPlayQuestionFooterIntroButton />
        )}

        {!step.isFirstSlide && (
          <Button
            variant="ghost"
            size="md"
            showTrailingIcon={false}
            aria-label="Slide anterior"
            leadingIcon={<ArrowLeftDoubleIcon variant="duotone" size={20} />}
            onClick={goToPrevStep}
            className="shrink-0 !px-0 w-[var(--btn-h-md)]"
          />
        )}
        {step.isLastSlide ? (
          <Button
            variant="primary"
            className="grow"
            showTrailingIcon={false}
            loading={isSubmitting}
            disabled={isSubmitting}
            onClick={() =>
              onQuestionContinue({ uid: activity.uid, advance: true })
            }
          >
            {isSubmitting ? 'Carregando' : 'Continuar'}
          </Button>
        ) : (
          <Button
            variant="secondary"
            className="grow"
            trailingIcon={<ArrowRightDoubleIcon variant="duotone" size={20} />}
            onClick={goToNextStep}
          >
            Próximo
          </Button>
        )}
      </LevelPlay.Footer>
    )
  if (_.isObject(interactionMode) && interactionMode.kind == 'continue')
    return (
      <LevelPlay.Footer id={id}>
        {step.hasIntro && (
          <DigitalProductQuizQuizPlayQuestionFooterIntroButton />
        )}
        <DigitalProductQuizQuizPlayQuestionFooterRightAnswerAlert
          question={activity}
        />

        <Button
          variant="primary"
          className="grow mt-auto"
          showTrailingIcon={false}
          loading={isSubmitting}
          disabled={
            interactionMode?.waitValidation && disableControls && !answerIsRight
          }
          onClick={() =>
            onQuestionContinue({ uid: activity.uid, advance: true })
          }
        >
          {isSubmitting ? 'Carregando' : 'Continuar'}
        </Button>
      </LevelPlay.Footer>
    )
  return (
    <LevelPlay.Footer id={id}>
      <DigitalProductQuizQuizPlayQuestionFooterWrongAnswerAlert />
      <DigitalProductQuizQuizPlayQuestionFooterRightAnswerAlert
        question={activity}
      />

      {step.hasIntro && <DigitalProductQuizQuizPlayQuestionFooterIntroButton />}

      {/* Ramo único: `disableControls` já inclui `answerIsEmpty`, então o CTA
          se desabilita sozinho enquanto não há resposta — igual à jornada. */}
      {!answerIsWrong && !answerIsRight && (
        <Button
          type="submit"
          variant="progress"
          className="grow mt-auto"
          showTrailingIcon={false}
          loading={isSubmitting}
          disabled={disableControls}
        >
          {isSubmitting
            ? saveAnswer
              ? 'Salvando'
              : 'Verificando'
            : saveAnswer
              ? 'Responder'
              : 'Verificar'}
        </Button>
      )}

      {answerIsWrong && (
        <Button
          variant="danger"
          className="grow mt-auto"
          showTrailingIcon={false}
          onClick={() =>
            allowWrongAnswers
              ? onQuestionAdvance()
              : onQuestionRetry({ keepAnswer: interactionMode?.keepAnswer })
          }
        >
          Entendido!
        </Button>
      )}

      {answerIsRight && (
        <Button
          variant="success"
          className="grow mt-auto"
          showTrailingIcon={false}
          onClick={onQuestionAdvance}
        >
          Continuar
        </Button>
      )}
    </LevelPlay.Footer>
  )
}
